import { Chakra } from "@airhelp/react-ui-components";
import type { Row } from "react-table";
import { SCORE_RANKING_COLORS } from "../../styles";

const { Text } = Chakra;

const positionCellCallback = ({
  row: {
    original: { position },
  },
}) => (
  <Text fontSize="sm" as="span">
    {position}.
  </Text>
);

const scoreCellCallback = ({
  row: {
    original: { score, position },
  },
}) => (
  <Text
    fontSize="sm"
    as="span"
    px={2}
    py={1}
    bg={SCORE_RANKING_COLORS[position]}
    rounded="5px"
    color={position <= 3 ? "white" : "inherit"}
    maxW="min-content"
  >
    {Number(score).toFixed(2)}
  </Text>
);

const sortTypeCallback = (rowA: Row, rowB: Row, id: string) => {
  const a = rowA.original[id];

  const b = rowB.original[id];

  if (a > b) return -1;

  if (b > a) return 1;

  return 0;
};

const columns = [
  { Header: "", accessor: "position", disableSortBy: true, Cell: positionCellCallback },
  { Header: "airline", accessor: "airline", disableSortBy: true },
  {
    Header: "airhelp_score",
    accessor: "score",
    Cell: scoreCellCallback,
    sortType: sortTypeCallback,
    sortDescFirst: true,
  },
  { Header: "on_time_performance", accessor: "ot_performance", Cell: ({ value }) => Number(value).toFixed(2) },
  { Header: "service_quality", accessor: "skytrax", Cell: ({ value }) => Number(value).toFixed(2) },
  { Header: "claim_processing", accessor: "claim_processing_score", Cell: ({ value }) => Number(value).toFixed(2) },
];

export default columns;
